module.exports = __webpack_public_path__ + "img/t5.d457f144.png";